import { render, staticRenderFns } from "./QuickAccessButtons.vue?vue&type=template&id=37462166&"
import script from "./QuickAccessButtons.vue?vue&type=script&lang=js&"
export * from "./QuickAccessButtons.vue?vue&type=script&lang=js&"
import style0 from "./QuickAccessButtons.vue?vue&type=style&index=0&id=37462166&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37462166')) {
      api.createRecord('37462166', component.options)
    } else {
      api.reload('37462166', component.options)
    }
    module.hot.accept("./QuickAccessButtons.vue?vue&type=template&id=37462166&", function () {
      api.rerender('37462166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/QuickAccessButtons.vue"
export default component.exports